import { ITechnologia } from "../tree/ITechnologia"
import Store from "@/store/Store"; 
import { MasterData } from "@/store/MasterData"; 
import { IIdx } from "./IIdx";
import { ITree } from "@/tree/ITree";
import { IColor } from "@/types/IColor";
import { ILbl } from "@/lbl/ILbl";
import { IWykrojnikRow } from "@/wykrojniki/IWykrojnikRow";
import { WykrojnikSvc } from "@/wykrojniki/WykrojnikSvc";
import { TreeCostParams } from "@/tree/TreeCostParams";

export class IdxImporter {

    static counter:any={}

    public static async get_sur(technologia:ITechnologia) {

        let surowiec_handlowy = ""
        const masterData: MasterData|undefined = await (await new Store().getStore()).masterData;
        if (masterData!=undefined) {
        const ids:any={}
            const typ:string = technologia.komponent_typ;
            const komponenty:any=masterData.komponenty;
            if (komponenty[typ]) {
            for (let j=0;j<komponenty[typ].length;j++) {
                const komp = komponenty[typ][j]
                if (komp._id == technologia.komponent_id) {
                    if (!komp.data_surowiec_handlowy) console.error("Brak surowca handlowego",komp.data_komponent_nazwa)
                    if (komp.data_surowiec_handlowy) console.error("Surowiec handlowy",komp.data_komponent_nazwa,komp.data_surowiec_handlowy)
                    if (komp.data_surowiec_handlowy && komp.data_surowiec_handlowy.indexOf("BRAK_SUR_HANDL")>-1)  
                    {   
                        console.log("return ",technologia.komponent_typ+":"+technologia.komponent_nazwa)
                        return technologia.komponent_typ+":"+technologia.komponent_nazwa;
                    }
                    surowiec_handlowy=komp.data_surowiec_handlowy
                    console.log("get_sur", komp.data_komponent_nazwa,"returns",komp.data_surowiec_handlowy)
                    return surowiec_handlowy;
                } 
                //else console.log("BRAK ZGODNOŚCI ID",komp.data_komponent_nazwa, technologia.komponent_nazwa)
            }
            }
        }

        return surowiec_handlowy;
    }

    public static get_counter(t:string) {
        if (!this.counter[t]) return 0;
        else return this.counter[t];
    }

    public static ass(idx:IIdx,cee:string,ctt:string,ee:string,tt:string,t:string, value:any) {

        if (!(cee==ee && ctt==tt)) return;

        const counted:boolean = (t.slice(-1)=="_");
        if (!counted) {
            if (!this.counter[t]) this.counter[t]=0;
            this.counter[t]++;
            (<any>idx)[t] = value;
            console.log(t,":=",value)
        } else {
            if (!this.counter[t]) this.counter[t]=0;
            this.counter[t]++;
            const prop:string  = t+this.counter[t];
            (<any>idx)[prop] = value;
            console.log(prop,":=",value)
        }
    }

    public static async fill_from_lbl(idx: IIdx, lbl:ILbl) {

        idx.nr_indeksu = lbl.nr_indeksu
        idx.nr_indeksu_wzor = lbl.nr_indeksu_wzor
        
        if (lbl.idn)  idx.nazwa_etykiety = lbl.idn;
        else idx.nazwa_etykiety = ''
        /*
        if (idx.indeks_finder && idx.indeks_finder.data && idx.indeks_finder.data.data_indeks_etykiety) {
            idx.nr_indeksu_wzor = idx.indeks_finder.data.data_indeks_etykiety;
        }
        */
        idx.kalk_id = 0
    
        idx.kalk_id = parseInt(lbl.kalkulacja_finder._id)
        
        idx.kto_projektowal = lbl.kto_projektowal;
        idx.kto_przygotowal_do_druku = lbl.kto_przygotowal_do_druku

        idx.numer_indeksu_u_klienta = lbl.numer_indeksu_u_klienta
        idx.barcode = lbl.barcode
        idx.specyfikacja_klienta = lbl.specyfikacja_klienta
        idx.wspolny_montaz = lbl.wspolny_montaz
        idx.nawijanie = lbl.nawijanie
        idx.nr_indeksu_matka = lbl.nr_indeksu_matka
        idx.nr_indeksu_wzor = lbl.nr_indeksu_wzor
        idx.srednica_wewn_gilzy = lbl.srednica_wewn_gilzy
        idx.srednica_zewn_rolki = lbl.srednica_zewn_rolki
        idx.pakowanie = lbl.pakowanie
        idx.uwagi = lbl.uwagi
        idx.uwagi1 = lbl.uwagi1
        idx.uwagi_przy_etykiecie = lbl.uwagi_przy_etykiecie

        idx.czy_zlikwidowane_polimery = lbl.czy_zlikwidowane_polimery 
        if (!idx.czy_zlikwidowane_polimery) idx.czy_zlikwidowane_polimery='NIE'
        idx.wyroznik = lbl.wyroznik
        idx.etykieta_flekso  = lbl.etykieta_flekso
        idx.grupa_maszyn = lbl.grupa_maszyn_ERP
        
    }


    public static async fill_from_colors(index: IIdx, colors:IColor[], rzeczywiste:boolean) {

        const idx:any=index;
        idx.cyfra_kolory = 0
        idx.cyfra_biel_std = 0
        idx.cyfra_biel_premium = 0
        idx.sito = 0
        if (rzeczywiste) {
            idx.ilosc_kolorow_rzeczyw = 0
        } else {
            idx.ilosc_kolorow_zakl = 0
        }
        

        for (let i=1;i<21;i++) {

            idx['kolor_'+i] = ''
            idx['wspolnota_kolorow_'+i] = ''
            idx['wersja_we_wspolnocie_kolorow_'+i] = ''
            idx['nr_farby_grafpol_'+i] = ''
    
            const color=colors[i-1]
            if (color) {
                if (color.kolor)  idx['kolor_'+i] = (<any>color).nazwa
                if (color.wspolnota_kolorow) idx['wspolnota_kolorow_'+i] = color.wspolnota_kolorow
                if (color.nr_farby_grafpol) idx['nr_farby_grafpol_'+i] = color.nr_farby_grafpol

                if (rzeczywiste) {
                    if (color.operacja=="cmyk")     idx.ilosc_kolorow_rzeczyw++;
                    if (color.operacja=="pantone")  idx.ilosc_kolorow_rzeczyw++;
                } else {
                    if (color.operacja=="cmyk")     idx.ilosc_kolorow_zakl++;
                    if (color.operacja=="pantone")  idx.ilosc_kolorow_zakl++;
                }

                if (color.operacja=="kolor cyfra")  idx.cyfra_kolory ++
                if (color.operacja=="biały cyfra")  idx.cyfra_biel_std ++

            }
        }

    }
    
    public static async fill_from_tree(idx: IIdx, tree:ITree) {

        const ee:string=""
        const tt:string=""

        this.counter={}

        idx.kalk_id = tree._id;
        // idx.nazwa_etykiety = tree.idn; // przejmowane z lbl

        const scp = new TreeCostParams(tree)
        idx.cyfra_kolory = scp.kolorCyfra;
        idx.ilosc_kolorow_flexo = scp.kolory;
        idx.cyfra_biel_std = scp.bielCyfra;
        idx.cyfra_biel_premium = 0
        idx.ilosc_kolorow_zakl=scp.kolorCyfra + scp.kolory;
        idx.sito = scp.sito;
        idx.formatkowanie = "NIE                 " //masterData.formatkowanie_sel

        idx.technologia = "5";
        if ( idx.ilosc_kolorow_flexo ) idx.technologia = "4"


        const wykrojnik_sel = <IWykrojnikRow> await new WykrojnikSvc().get_selected_wykrojnik_for_tree(tree._id) 
        const nr= wykrojnik_sel?.numer;
        if (nr) {
            idx.nr_wykrojnika = nr.toString();
            console.log(tree.stat)
        }

        for (let i=0;i<tree.etapy.length;i++) {
            const etap=tree.etapy[i]
            const ee = etap.etap_typ
            for (let j=0;j<etap.technologie.length;j++) {
                const technologia = etap.technologie[j]
                const tt = technologia.typ;

                if (tt.indexOf("gilza fi ")>-1) {
                    const fi = tt.replace("gilza fi ","")
                    if (fi) {
                        idx.srednica_wewn_gilzy = fi
                    }
                }

                
                if (tt=="formatkowanie") {
                    idx.formatkowanie="TAK                 "
                }

                this.ass(idx,ee,tt,"ETAP_START","surowiec","specjalna_szerokosc_wstegi_",technologia.komponent_szerokosc)

                this.ass(idx,ee,tt,"ETAP_START","surowiec","surowiec_",await IdxImporter.get_sur(technologia))

                if (technologia.surowiec) {    
                    this.ass(idx,ee,tt, "ETAP_FLEKSO","cs","uszlachetnienie_krotnosc_wstega_",technologia.krotnosc)
                    this.ass(idx,ee,tt, "ETAP_FLEKSO","cs","uszlachetnienie_wstega_",technologia.surowiec.surowiec_idm)
                    this.ass(idx,ee,tt, "ETAP_FLEKSO","cs distorun","uszlachetnienie_krotnosc_wstega_",technologia.krotnosc)
                    this.ass(idx,ee,tt, "ETAP_FLEKSO","cs distorun","uszlachetnienie_wstega_",technologia.surowiec.surowiec_idm)
                    this.ass(idx,ee,tt, "ETAP_FLEKSO","cs distorun soczewka","uszlachetnienie_krotnosc_wstega_",technologia.krotnosc)
                    this.ass(idx,ee,tt, "ETAP_FLEKSO","cs distorun soczewka","uszlachetnienie_wstega_",technologia.surowiec.surowiec_idm)
                    this.ass(idx,ee,tt, "ETAP_FLEKSO","hs","uszlachetnienie_krotnosc_wstega_",technologia.krotnosc)
                    this.ass(idx,ee,tt, "ETAP_FLEKSO","hs","uszlachetnienie_wstega_",technologia.surowiec.surowiec_idm)
                }
               
                this.ass(idx,ee,tt, "ETAP_FLEKSO","polimery 114","grupa_maszyn","CYL. 1,14".padEnd(20))

                this.ass(idx,ee,tt, "ETAP_FLEKSO","kolor cyfra","rodzaj_farb","CYFROWE HP".padEnd(20)) // default
                this.ass(idx,ee,tt, "ETAP_FLEKSO","start zlecenia","rodzaj_farb","UV FLEXO".padEnd(20)) // default
                this.ass(idx,ee,tt, "ETAP_FLEKSO","farby uv","rodzaj_farb","UV FLEXO".padEnd(20)) // default
                this.ass(idx,ee,tt, "ETAP_FLEKSO","farby wodne","rodzaj_farb","WODNE FLEXO".padEnd(20)) // default
                
                this.ass(idx,ee,tt, "ETAP_FLEKSO","sito","sito",this.get_counter("sito")+1) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","sito puchn","sito",this.get_counter("sito")+1) 

/*  
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier wodny"                ,"lakierowanie_","WODNY".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier uv"                   ,"lakierowanie_","UV FLEXO".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier wodny miejscowy"      ,"lakierowanie_","WODNY".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier uv miejscowy"         ,"lakierowanie_","UV FLEXO".padEnd(20)) 
*/              
                this.ass(idx,ee,tt,"ETAP_FLEKSO","lakier uv","lakierowanie_",await IdxImporter.get_sur(technologia))
                this.ass(idx,ee,tt,"ETAP_FLEKSO","lakier uv miejscowy","lakierowanie_",await IdxImporter.get_sur(technologia))


                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier wodny"                ,"lakierowanie_typ_","APLA".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier uv"                   ,"lakierowanie_typ_","APLA".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier wodny miejscowy"      ,"lakierowanie_typ_","MIEJSCOWY".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier uv miejscowy"         ,"lakierowanie_typ_","MIEJSCOWY".padEnd(20)) 

                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier wodny"                ,"rodzaj_farb","WODNE FLEXO".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier uv"                   ,"rodzaj_farb","UV FLEXO".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier wodny miejscowy"      ,"rodzaj_farb","WODNE FLEXO".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","lakier uv miejscowy"         ,"rodzaj_farb","UV FLEXO".padEnd(20)) 

                this.ass(idx,ee,tt, "ETAP_FLEKSO","poddruk na folii"            ,"poddruk_na_kleju_lub_silikonie","TAK".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FLEKSO","poddruk na papierze"         ,"poddruk_na_kleju_lub_silikonie","TAK".padEnd(20)) 

                this.ass(idx,ee,tt, "ETAP_FLEKSO","formatkowanie"               ,"formatkowanie","TAK".padEnd(20)) 
                

                this.ass(idx,ee,tt, "ETAP_FLEKSO","formatkowanie"               ,"formatkowanie","TAK".padEnd(20)) 

                this.ass(idx,ee,tt, "ETAP_FINISHING","polimery 114","grupa_maszyn","CYL. 1,14".padEnd(20))

                this.ass(idx,ee,tt, "ETAP_FINISHING","lakier wodny"                ,"lakierowanie_","WODNY".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FINISHING","lakier uv"                   ,"lakierowanie_","UV FLEXO".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FINISHING","lakier wodny miejscowy"      ,"lakierowanie_","WODNY".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FINISHING","lakier uv miejscowy"         ,"lakierowanie_","UV FLEXO".padEnd(20)) 

                this.ass(idx,ee,tt, "ETAP_FINISHING","lakier wodny"                ,"lakierowanie_typ_","APLA".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FINISHING","lakier uv"                   ,"lakierowanie_typ_","APLA".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FINISHING","lakier wodny miejscowy"      ,"lakierowanie_typ_","MIEJSCOWY".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_FINISHING","lakier uv miejscowy"         ,"lakierowanie_typ_","MIEJSCOWY".padEnd(20)) 

                this.ass(idx,ee,tt, "ETAP_PRZEWIJARKA","gilza fi 25"         ,"srednica_wewn_gilzy","25".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_PRZEWIJARKA","gilza fi 40"         ,"srednica_wewn_gilzy","40".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_PRZEWIJARKA","gilza fi 45"         ,"srednica_wewn_gilzy","45".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_PRZEWIJARKA","gilza fi 50"         ,"srednica_wewn_gilzy","50".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_PRZEWIJARKA","gilza fi 76"         ,"srednica_wewn_gilzy","76".padEnd(20)) 
                this.ass(idx,ee,tt, "ETAP_PRZEWIJARKA","gilza fi 120"        ,"srednica_wewn_gilzy","120".padEnd(20)) 

            }
        }                   
 
    }

}